export const uploadProfileParams = {
  "signedURLType": "download",
  "fileCategory": "",
  "objectType": "",
  "filename": "",
  "objectId": null,
  "contentType": "image/png"
}